import PropTypes from 'prop-types';

import { classList } from '../../utils';
import styles from './styles.scss';

BigHeading.propTypes = {
  level: PropTypes.number,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

/**
 * A big, fat heading.
 */
export default function BigHeading({ level = 2, children, className }) {
  const Tag = `h${level}`;
  return (
    <Tag
      className={classList({
        [styles.root]: true,
        [className]: className != null,
      })}
    >
      {children}
    </Tag>
  );
}
